<template>
  <div>
	      <div class="test-indicator-block" v-if="questions && isPreview">
      <div class="indicate-50">
        <div class="indicate-num green">{{legendsCount.easy}}</div>
        <div class="indicate-text">Easy</div>
      </div>
      
      <div class="indicate-50">
        <div class="indicate-num yellow">{{legendsCount.moderate}}</div>
        <div class="indicate-text">Moderate</div>
      </div>
	  <div class="indicate-50">
        <div class="indicate-num red">{{legendsCount.tough}}</div>
        <div class="indicate-text">Tough</div>
      </div>
    </div>
    <div class="test-indicator-block" v-else-if="questions">
      <div class="indicate-50">
        <div class="indicate-num green">{{legendsCount.answered}}</div>
        <div class="indicate-text">Answered</div>
      </div>
      <div class="indicate-50">
        <div class="indicate-num gray">{{legendsCount.notVisited}}</div>
        <div class="indicate-text">Not Visited</div>
      </div>
      <div class="indicate-50">
        <div class="indicate-num red">{{legendsCount.notAnswered}}</div>
        <div class="indicate-text">Not Answered</div>
      </div>
      <div class="indicate-50">
        <div class="indicate-num yellow">{{legendsCount.reviewLater}}</div>
        <div class="indicate-text">Review Later</div>
      </div>
      <div class="indicate-100">
        <div class="indicate-num green">
          {{legendsCount.answeredReviewLater}}
          <span class="doth-span"></span>
        </div>
        <div class="indicate-text">
          Answered & Marked for Review
          <br />
          <span class="indicate-red-text">(Will be considered for evaluation)</span>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import constants from "@/utils/constants.js";

export default {
  name: "LegendsPreview",
  props: ["questions", "questionStatus","isPreview","isCustom"],

  data() {
    return {
      legendsCount: {
        answered: 0,
        notAnswered: 0,
        notVisited: 0,
        reviewLater: 0,
        answeredReviewLater: 0,
		easy:0,
		moderate:0,
		tough:0
      }
    };
  },
  mounted() {
    this.loadLegends();
  },
  methods: {
    loadLegends() {
      if(!this.questions) return;
      this.legendsCount = {
          answered: 0,
          notAnswered: 0,
          notVisited: 0,
          reviewLater: 0,
          answeredReviewLater: 0,
		  easy:0,
		  moderate:0,
		  tough:0
        };
        this.questions.forEach(val => {
          if (val.status == this.questionStatus.ANSWER_SELECTED_SAVED) {
            this.legendsCount.answered++;
          }
          if (val.status == this.questionStatus.ANSWER_NOT_SELECTED_REVIEW) {
            this.legendsCount.reviewLater++;
          }
          if (val.status == this.questionStatus.ANSWER_SELECTED_REVIEW) {
            this.legendsCount.answeredReviewLater++;
          }
          if (val.status < this.questionStatus.VISITED) {
            this.legendsCount.notVisited++;
          }
          if (val.status == this.questionStatus.VISITED && !val.isAnswered || val.status == this.questionStatus.ANSWER_NOT_SELECTED_SAVED) {
            this.legendsCount.notAnswered++;
          }
		  if(val.difficulty_level === constants.DIFFICULTY_LEVELS[0].id){
			  this.legendsCount.easy ++;
		  }
		  if(val.difficulty_level === constants.DIFFICULTY_LEVELS[1].id){
			  this.legendsCount.moderate ++;
		  }
		  if(val.difficulty_level === constants.DIFFICULTY_LEVELS[2].id){
			  this.legendsCount.tough ++;
		  }

		   if(val.difficulty_level === null && val.institute_id){
			  this.legendsCount.moderate ++;
		  }
        });
    },
  },
  watch: {
    questions: {
      handler(newVal, oldVal) {
        this.legendsCount = {
          answered: 0,
          notAnswered: 0,
          notVisited: 0,
          reviewLater: 0,
          answeredReviewLater: 0,
		  easy:0,
		  moderate:0,
		  tough:0
        };
        newVal.forEach(val => {
          if (val.status == this.questionStatus.ANSWER_SELECTED_SAVED) {
            this.legendsCount.answered++;
          }
          if (val.status == this.questionStatus.ANSWER_NOT_SELECTED_REVIEW) {
            this.legendsCount.reviewLater++;
          }
          if (val.status == this.questionStatus.ANSWER_SELECTED_REVIEW) {
            this.legendsCount.answeredReviewLater++;
          }
          if (val.status < this.questionStatus.VISITED) {
            this.legendsCount.notVisited++;
          }
          if (val.status == this.questionStatus.VISITED && !val.isAnswered || val.status == this.questionStatus.ANSWER_NOT_SELECTED_SAVED) {
            this.legendsCount.notAnswered++;
          }
		  if(val.difficulty_level === constants.DIFFICULTY_LEVELS[0].id){
			  this.legendsCount.easy ++;
		  }
		  if(val.difficulty_level === constants.DIFFICULTY_LEVELS[1].id){
			  this.legendsCount.moderate ++;
		  }
		  if(val.difficulty_level === constants.DIFFICULTY_LEVELS[2].id){
			  this.legendsCount.tough ++;
		  }
		  if(val.institute_id && val.difficulty_level==null){
			  this.legendsCount.moderate ++;

		  }
        });        
      },
      deep: true
    }
  },
};
</script>